/* global countdownData */
jQuery(document).ready(function ($) {
  if (
    (!$("body").hasClass("single-studio") && !$("body").hasClass("promo-page")) ||
    typeof countdownData === "undefined"
  ) {
    return;
  }

  const targetDateObj = new Date(countdownData.date);
  const countdownElement = document.getElementById("promo-countdown");
  const countdownUnits = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  setInterval(function () {
    const currentDate = new Date();
    const difference = Math.floor((targetDateObj - currentDate) / 1000);
    countdownUnits.days = Math.floor(difference / (60 * 60 * 24));
    countdownUnits.hours = Math.floor((difference % (60 * 60 * 24)) / (60 * 60)).toLocaleString("de-DE", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    countdownUnits.minutes = Math.floor((difference % (60 * 60)) / 60).toLocaleString("de-DE", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    countdownUnits.seconds = Math.floor(difference % 60).toLocaleString("de-DE", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });

    let countdownHTML = "";
    Object.keys(countdownUnits).forEach(function (unit) {
      countdownHTML +=
        '<div class="promo-countdown__item"><div class="promo-countdown__item-number">' +
        countdownUnits[unit] +
        "</div>" +
        '<div class="promo-countdown__item-dots"><div></div><div></div></div>' +
        '<div class="promo-countdown__item-description">' +
        countdownData.texts[unit] +
        "</div></div>";
    });
    countdownElement.innerHTML = countdownHTML;
  }, 1000); // Update every second
});
